module.exports = __webpack_public_path__ + "assets/2523c32aa3dc6c4c4754d90965051529.svg";